/**
 * @generated SignedSource<<26a560d50e5a11b22fae5d88c780a665>>
 * @relayHash 3e442d5d3227540b5f9648827533c2f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cd1ae3e91e6cce9d7c559a091c26b1b5d144b0cbd98427fa9498628b398d03cd

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type relaySyncBlockFetchProviderSubscription$variables = {
  resourceId: string;
};
export type relaySyncBlockFetchProviderSubscription$data = {
  readonly blockService_onBlockUpdated: {
    readonly blockAri: string;
    readonly blockInstanceId: string;
    readonly content: string;
    readonly contentUpdatedAt: number | null | undefined;
    readonly createdAt: number;
    readonly createdBy: string;
    readonly deletionReason: string | null | undefined;
    readonly product: string;
    readonly sourceAri: string;
    readonly status: string;
  } | null | undefined;
};
export type relaySyncBlockFetchProviderSubscription = {
  response: relaySyncBlockFetchProviderSubscription$data;
  variables: relaySyncBlockFetchProviderSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resourceId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "resourceId",
        "variableName": "resourceId"
      }
    ],
    "concreteType": "BlockServiceBlockPayload",
    "kind": "LinkedField",
    "name": "blockService_onBlockUpdated",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "blockAri"
      },
      {
        "kind": "ScalarField",
        "name": "blockInstanceId"
      },
      {
        "kind": "ScalarField",
        "name": "content"
      },
      {
        "kind": "ScalarField",
        "name": "contentUpdatedAt"
      },
      {
        "kind": "ScalarField",
        "name": "createdAt"
      },
      {
        "kind": "ScalarField",
        "name": "createdBy"
      },
      {
        "kind": "ScalarField",
        "name": "deletionReason"
      },
      {
        "kind": "ScalarField",
        "name": "product"
      },
      {
        "kind": "ScalarField",
        "name": "sourceAri"
      },
      {
        "kind": "ScalarField",
        "name": "status"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "relaySyncBlockFetchProviderSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "relaySyncBlockFetchProviderSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3e442d5d3227540b5f9648827533c2f8",
    "id": "cd1ae3e91e6cce9d7c559a091c26b1b5d144b0cbd98427fa9498628b398d03cd",
    "metadata": {},
    "name": "relaySyncBlockFetchProviderSubscription",
    "operationKind": "subscription",
    "text": "subscription relaySyncBlockFetchProviderSubscription($resourceId:ID!){blockService_onBlockUpdated(resourceId:$resourceId){blockAri,blockInstanceId,content,contentUpdatedAt,createdAt,createdBy,deletionReason,product,sourceAri,status}}"
  }
};
})();

(node as any).hash = "f3661ea7b2ab697a90b3ec5ef8d55382";

export default node;
